import CartProductCard from '@Components/CartPage/CartProductCard';
import useTranslation from 'next-translate/useTranslation';
import { CartProduct } from 'types/Cart';
import { Div, List, ListContent, ListHeader, P } from './PartsList.styled';

type Props = {
  car_str: string;
  items: CartProduct[];
};
export default function PartsList({ car_str, items }: Props) {
  const { t } = useTranslation('Cart');
  return (
    <List>
      <ListHeader>
        <P>{t('car_parts')}</P>
        <Div>
          <P>{car_str}</P>
          {/* <CarImage>
            <Image src={Car} width={70} height={50} alt="car" />
          </CarImage> */}
        </Div>
      </ListHeader>
      <ListContent>
        {items?.map((product) => (
          <CartProductCard data={product} key={product.id} />
        ))}
      </ListContent>
    </List>
  );
}
